<template>
  <vs-sidebar
    click-not-close
    position-right
    v-model="dialogShow"
    class="items-no-padding account-type-set sidebar-dialog">
    <div class="sidebar-content h-full">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div>
          {{title}}
        </div>
        <feather-icon icon="XIcon" @click.stop="closeHandle" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar
        class="scroll-area--customizer pt-4 pb-6" :settings="settings" :key="$vs.rtl"
      >
        <div class="content px-6">
          <account-type-set-form
            ref="typeform"
            :account-mt-id="accountMtId"
            :account-mt="accountMt"
            :dialog-show="dialogShow"
            @success-set="successSet"
          ></account-type-set-form>
        </div>
      </VuePerfectScrollbar>
    </div>
    <div
      class="footer-sidebar" slot="footer">
      <el-button
        @click="cancelHandle"
        type="text"
        class="calcel-btn"
      >{{$t('cancel')}}</el-button>
      <vs-button
        @click="submitHandle"
        color="primary"
      >{{$t('Confirm')}}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import { setBodyHidden,setBodyNormal } from "@/utils/common";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import accountTypeSetForm from "@/components/dashboard/accountTypeSetForm";
import { mapGetters } from 'vuex'
export default {
  name: "accountTypeSet",
  components: {
    accountTypeSetForm,
    VuePerfectScrollbar,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
    accountMtId: {},
    accountMt: {}
  },
  data() {
    let _this = this;
    return {
      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
      title: _this.$t('customerHome.Account_type_settings'),
    }
  },
  watch: {
    dialogShow(val){
      this.$refs.form && this.$refs.form.resetFields();
      this.$refs.form && this.$refs.form.clearValidate();
      if(val){
        setBodyHidden();
      }else {
        setBodyNormal();
      }
    },
    curLogin(newValue, oldValue) {
      if(newValue){
        this.form.login = newValue;
        this.$refs.form && this.$refs.form.clearValidate();
      }
    },
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  methods: {
    close(){
      this.$emit('close')
    },
    closeHandle() {
      this.$refs.typeform.clear();
      this.close();
    },
    interfaceAjaxSuccess(){
      this.$emit('ajax-success');
    },
    successSet(){
      this.interfaceAjaxSuccess();
    },
    submitHandle(){
      this.$refs.typeform.saveHandle();
    },
    cancelHandle(){
      this.close();
    }
  },
}
</script>
<style lang="scss">
.account-type-set {
  .content {
    padding-top: 30px;
  }
}
</style>
<style lang="scss">
.account-type-set {
  .vs-sidebar--items {

  }

  .vs-sidebar {
    z-index: 2009;
    position: fixed;
    .sidebar-content {
    }
  }
  // sidebar弹框的遮罩层
  .vs-sidebar--background {
    z-index: 1001!important;
  }

  .scroll-area--customizer {
    height: calc(100% - 4rem);
  }
  .footer-sidebar {
    padding: 20px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .calcel-btn {
      margin-right: 10px;
    }
  }
}
</style>
